import { jsx as _jsx } from "react/jsx-runtime";
import classNames from 'classnames';
export default function ButtonBadge({ title, className }) {
    return (_jsx("div", { className: classNames('bg-warning-light absolute -right-2 -top-1.5 w-fit rounded-full px-3 py-1 text-center text-xs shadow-sm transition-all', className), children: title }));
}
